<template>
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getFollowUpPersonnelList)" class="refresh-btn">刷新</el-button>
    <div class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="医馆名称">
            <el-select v-model="searchForm.deptIds" multiple placeholder="请选择医馆名称">
              <el-option v-for="item in deptOptions" :key="item.value"  :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="月份">
            <el-date-picker v-model="searchForm.date" value-format="yyyy-MM" type="monthrange" align="right"
            unlink-panels range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"
            :picker-options="pickerOptions" @change="val => $setDates(val, getFollowUpPersonnelList)"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getFollowUpPersonnelList, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getFollowUpPersonnelList, { deptIds: [], dates: [], date: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button @click="$exportSummary(searchForm, '/report/export/examPerson', '随访人员统计')"
          icon="el-icon-download" type="primary">导出报表</el-button>
      </div>
      <!-- 随访人员列表 -->
      <el-table v-loading="loading" :data="followUpPersonnelList" :max-height="tableHeight" border>
        <el-table-column label="医馆名称" prop="deptName" fixed/>
        <el-table-column label="开方医生" prop="doctorName"/>
        <el-table-column label="预计随访人员" prop="examPlanName" min-width="110"/>
        <el-table-column label="实际随访人员" prop="examRealityName" min-width="110"/>
        <el-table-column label="随访任务(个)" prop="taskNumber" min-width="110"/>
        <el-table-column label="已执行(个)" prop="completeNumber" min-width="90"/>
        <el-table-column label="待执行(个)" prop="waitNumber" min-width="90"/>
        <el-table-column label="已终止(个)" prop="stopNumber" min-width="90"/>
      </el-table>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getFollowUpPersonnelList)"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total"/>
    </div>
  </div>
</template>

<script lang="js">
import { followUpPersonnelStatistics } from "@/api/statement"; // 报表统计请求
export default {
  name: 'FollowupPersonnel',
  data() {
    return {
      loading: false, // 加载中
      searchForm: { deptIds: [], dates: [], date: null }, // 查询表单
      followUpPersonnelList: [], // 随访人员统计列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      deptOptions: this.$session.get('options'), // 医馆列表
      pickerOptions:{ // 排班日期可选范围
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: this.$shortcuts
      },
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.$forceUpdate();
    this.$setCurMonth(this.getFollowUpPersonnelList);
  },
  methods: {
    // 请求所有随访人员统计列表
    async getFollowUpPersonnelList() {
      let { rows, code, total } = await followUpPersonnelStatistics(this.currentPage, this.pageSize, this.searchForm);
      if (code == 200) {
        this.followUpPersonnelList = rows;
        this.total = total;
      }
      this.loading = false;
    }
  },
};
</script>